// For a guide on how to generate the sha/hash for an experiment, refer to the following Confluence doc:
// https://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/4157145092/How+To+Calculate+Experiment+Hash
const constants = {
  INTERNATIONA_SEARCH_CONTEXT_CLUES_EXPERIMENT: '34ddffdc75c9b368cdc0fb603cf8b8f5c61fb481',
  SITTER_CARD_REVIEWS_REDESIGN_EXPERIMENT: '7649d8c47ecfa108a60d55bca8d41adcace985ee',
  SEO_SITTER_CARD_EXPERIMENT: 'e8b99afa53eaf3e4cb68e438b2211d9e5478b78b',
  NEW_TO_ROVER_SITTER_EXPERIMENT: '0081c3c67526059a141a53290508e1c789a7023a',
  SIMPLIFIED_MOBILE_OWNER_SEARCH_FORM_EXPERIMENT: 'a904a169e9bf4173b7ce95697aa7960b1ea49c0e',
  GINGR_DAYCARE_FACILITIES_INCLUDED_IN_SEARCH_EXPERIMENT:
    '1a84f8db271031261b70760bdf42c63eeac7dc20',
  GINGR_BOARDING_FACILITIES_INCLUDED_IN_SEARCH_EXPERIMENT:
    '93f2780439c5eacb5d8226625f34d175d788af2a',
  GINGR_DAYCARE_FACILITIES_INCLUDED_IN_SEARCH_RESULTS_EXPERIMENT:
    'd06273af2245a2f751504fa75b3ce85438e230d5',
  GINGR_BOARDING_FACILITIES_INCLUDED_IN_SEARCH_RESULTS_EXPERIMENT:
    'a1c012c892f80aff0869f780ee9cb9b03d253115',
  GINGR_DAYCARE_FILTER_EARLIER_EXPERIMENT: '0f59724eee506bbdfd481873f20f2af5b7523563',
  GINGR_BOARDING_FILTER_EARLIER_EXPERIMENT: 'dbcc5e86cf7f44b39a143eb031ba79971b017281',
  GINGR_DAYCARE_FILTER_OUTSIDE_MARKETS_EXPERIMENT: '80589fb4a7ff1c103369741309467e4fcf1bfaa4',
  GINGR_BOARDING_FILTER_OUTSIDE_MARKETS_EXPERIMENT: 'b2714d1bb25f68b661000a99e1948ed5e9885ebf',
  ROLLOUT_ROVER_PROTECT_CH_2_EXPERIMENT: {
    value: '4518f028ea686d284dec86d055ff56129bcf0f56',
    roverProtectSignalsWithSurvey: 'show_roverprotect_signals_with_survey',
    roverProtectNoSignalsWithSurvey: 'show_no_roverprotect_signals_with_survey',
    holdout: 'holdout',
  },
  EXPERIMENT_PRICE_TRANSPARENCY: '8c512e0c7b884346bc064bad33b8bfab9f0b5497',
  PET_COUNTERS_EXPERIMENT: 'bac8dd75355ebb1a85642974af13b4751898960a',
  QUICK_FACTS: '6084a8f35600ecf3a7c8ecbba3e9cf061fcebc0a',
  HORIZONTAL_SITTER_RESULTS_CAROUSEL_EXPERIMENT: '802b2d4ed72cb6ef2e5991af7e37db92537a7699',
  PROMPT_FOR_ADDRESS_IN_LOCATION_FIELDS_EXPERIMENT: 'dd89c9b5e5da67bbcf351858faf918dbb5a1c49e',
  BYPASS_SEARCH_MODAL_EXPERIMENT: '72367afd908bdae957bc0159c5fe16df4e0501e0',
  CONDENSED_SEARCH_FORM_PRE_POST_EXPERIMENT: 'd33f5c5c81bbdd0160be6bfb0d06b2e9f8de41ed',
  CONDENSED_SEARCH_FORM_GEOSPLIT_EXPERIMENT: 'c4a5ed4b23a5470a7d5158c23298f35c5b37b951',
  SEARCH_THIS_AREA_EXPERIMENT: '372cb1c6b36188a67a5fa6b6d7788ff8d0ce5429',
  VALUE_PROP_FILTER_OPTIONS_EXPERIMENT: '54c0c867fd0d76b2dcf515940ffeafeb0b2fd011',
};
export default constants;
